function mapToParentSection(data) {
  const bankBranchCode = `${data.bsbNumber || ''}${data.institutionNumber || ''}`;
  return {
    bankAccountName: data.accountHolder,
    bankAccountNumber: data.accountNumber,
    bankBranchName: data.branch,
    bankBranchCode,
    bankName: data.nameOfBank,
    ABNNumber: data.abn,
    gstRegistered: data.registerForGSTPurpose,
    gstPercentageClaimed: data.percentageOfGST,
    claimInputTaxCredit: data.claimITC,
    creditorExtension: {
      paymentVia: "EFT",
    },
    bankCodeType: "Bank Code",
  };
}

function mapToQuestionnaire(data, claimCode) {
  return [
    {
      question: 'section1.otherInsurance',
      answer: data.otherInsurance,
      claimTypeCode: claimCode,
    },
    {
      question: 'section1.provideDetails',
      answer: data.provideDetails,
      claimTypeCode: claimCode,
    },
  ];
}

function mapToExpenses() {
  return [];
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepAppsureBankDetailsDataMapper.js